import React from "react";
import SelectableTextBox from "~/components/inputs/SelectableTextBox";
import { isPropertyEnabled, translatePropertyValue } from "../propertyCore";
import CheckboxPropertySelectorWrapper from "./common/CheckboxPropertySelectorWrapper";

export default function CheckboxPropertySelector(props) {
    const { appProps, exchangeAlternatives, selectedProperties, selectedPropertyValue, propertyValues, propertyType, onSelectedPropertyValue } = props;

    return (
        <CheckboxPropertySelectorWrapper {...props}>
            {propertyValues.map(({ value: propertyValue }) => {
                let selected = selectedPropertyValue === propertyValue;
                let disabled = !isPropertyEnabled({
                    exchangeAlternatives,
                    propertyType,
                    propertyTypeChoices: selectedProperties,
                    propertyValue: propertyValue,
                });
                return (
                    <SelectableTextBox
                        appProps={appProps}
                        key={propertyValue}
                        dataTestId={`item-property-${propertyType}-${propertyValue}`}
                        selected={selected}
                        disabled={disabled}
                        onClick={() => onSelectedPropertyValue({ propertyValue: propertyValue })}
                        text={translatePropertyValue({ ...props, propertyValue: propertyValue })}
                    />
                );
            })}
        </CheckboxPropertySelectorWrapper>
    );
}
